import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomTicketsComponent} from './custom-tickets.component';
import {AuthGuard, CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {effectsTickets} from './store/effects/custom-tickets.effect';
import {TICKETS_FEATURE} from './store/custom-tickets-state';
import {reducerTicketsProvider, reducerTicketsToken} from './store/reducers/custom-ticket.reducer';
import {PaginationModule, SpinnerModule} from '@spartacus/storefront';
import {CustomPipesModule} from '../../../../../custom/pipes/custom-pipes';


@NgModule({
  declarations: [CustomTicketsComponent],
  providers: [reducerTicketsProvider],
  imports: [
    CommonModule,
    EffectsModule.forFeature(effectsTickets),
    StoreModule.forFeature(TICKETS_FEATURE, reducerTicketsToken),
    ConfigModule.withConfig({
      cmsComponents: {
        AccountTicketsHistoryComponent: {
          component: CustomTicketsComponent,
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
    SpinnerModule,
    I18nModule,
    CustomPipesModule,
    PaginationModule,
  ]
})
export class CustomTicketsModule {
}
